import { buildMaybePartnerRoute } from '../../helpers/builders.js';
import { VisitsPageRouteName } from './model.js';

const visitsPageRoute = (locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: VisitsPageRouteName.VISITS_PAGE,
    path: '/office/visits',
    params: {
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
    },
});

export { visitsPageRoute };
